import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

function SortRow(props) {
    const { sortDetail } = props;
    const [open, setOpen] = React.useState(false);


    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>
                    {sortDetail.ParentField ?
                        <>
                            {sortDetail.ParentField}.{sortDetail.Field}
                        </>
                        :
                        <>
                            {sortDetail.Field}
                        </>
                    }
                </TableCell>
                <TableCell>{sortDetail.Value}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Typography variant="h6" gutterBottom component="div">
                                Sort Details
                            </Typography>
                            <Table size="small" aria-label="Details">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Dir</TableCell>
                                        <TableCell>Missing</TableCell>
                                        <TableCell>Raw Value</TableCell>
                                        <TableCell>Value Field</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>{sortDetail.Direction}</TableCell>
                                        <TableCell>{sortDetail.MissingPosition}</TableCell>
                                        <TableCell>{sortDetail.RawValue}</TableCell>
                                        <TableCell>{sortDetail.ValueField}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                            {sortDetail.IsFeaturedSort &&
                                <>
                                    <br />
                                    <Typography variant="h6" gutterBottom component="div">
                                        Featured Details
                                    </Typography>
                                    <Table size="small" aria-label="Featured Details">
                                        <TableHead>
                                            <TableRow>
                                            <TableCell>ID</TableCell>
                                                <TableCell>Publication Type ID</TableCell>
                                                <TableCell>Publication Type</TableCell>
                                                <TableCell>Edition Type ID</TableCell>
                                                <TableCell>Edition Type</TableCell>
                                                <TableCell>Weight Type</TableCell>
                                                <TableCell>Ad Type</TableCell>
                                                <TableCell>Sort Ranking ID</TableCell>
                                                <TableCell>Item Types</TableCell>
                                            </TableRow>
                                        </TableHead>
                                    <TableBody>
                                        {sortDetail.FeaturedDetails?.map((featuredDetail) => (
                                            <TableRow key={`${featuredDetail.PublicationTypeID}-${featuredDetail.EditionTypeID}`}>
                                                <TableCell>{featuredDetail.FeaturedListingID}</TableCell>
                                                <TableCell>{featuredDetail.PublicationTypeID}</TableCell>
                                                <TableCell>{featuredDetail.PublicationType}</TableCell>
                                                <TableCell>{featuredDetail.EditionTypeID}</TableCell>
                                                <TableCell>{featuredDetail.EditionType}</TableCell>
                                                <TableCell>{featuredDetail.WeightType}</TableCell>
                                                <TableCell>{featuredDetail.AdType}</TableCell>
                                                <TableCell>{featuredDetail.FeaturedListingSortID}</TableCell>
                                                <TableCell>
                                                    {(featuredDetail.ItemTypes || []).join(', ')}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                </>
                            }
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

const EmployeeListingSort = (props) => {
    const {
        listingId,
        domainName,
        sortApplied,
        sortValues
    } = props;

    const shouldRender = sortApplied?.Fields?.length > 0 && sortValues?.length > 0;
    const [showTable, setShowTable] = React.useState(false);
    const [isLoaded, setLoaded] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const [sortDetails, setSortDetails] = React.useState(false);
    const routes = useRecoilValue(atoms.routes);

    const toggleDetails = () => {
        if (!isLoaded) {
            setLoading(true);
            sandhillsRequest({
                method: 'post',
                url: routes.ListingsParseSort,
                data: {
                    SortApplied: sortApplied,
                    ListingSorts: [
                        {
                            ListingID: listingId,
                            DomainName: domainName,
                            SortValues: sortValues
                        }
                    ]
                },
                errorHandling: {
                    message: 'Fatal Error',
                    showDetails: true,
                    useConsole: true,
                    useAlert: false
                }
            })
                .then((response) => {
                    console.log("Response: ", response);
                    if (response) {
                        setSortDetails(response[0].SortDetails);
                        setShowTable(true);
                    } else {
                        console.error("Failure", response);
                    }
                })
                .finally(() => {
                    setLoaded(true);
                    setLoading(false);
                });
        }
        else {
            setShowTable(prevState => !prevState);
        }
    };

    return (
        <>
            {shouldRender &&
                <Box pb={1}>
                    <Button variant='contained' size='small' onClick={toggleDetails}>
                        <Icon baseClassName="fas" className={showTable ? 'fa-caret-down' : 'fa-caret-right'} />
                        {!showTable ? 'Show' : 'Hide'} Sort Details
                    </Button>
                    {showTable &&
                        <Box pt={1}>
                            <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell />
                                            <TableCell sx={{ fontWeight: '700' }}>Matching Field</TableCell>
                                            <TableCell sx={{ fontWeight: '700' }}>Value</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sortDetails?.map((sortDetail, index) => (
                                            <SortRow key={index} sortDetail={sortDetail} />
                                        ))}
                                        {props.HashValue &&
                                            <TableRow>
                                            <TableCell sx={{ fontWeight: '700' }}>Hash Value: </TableCell>
                                                <TableCell sx={{ fontWeight: '700' }}>{props.HashValue}</TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    }
                </Box>
            }
            {isLoading &&
                <LoadingRing backdrop />}
        </>
    );
};

export default EmployeeListingSort;